import React, {useState, useEffect} from "react";
import { userModel } from "../index.js";
import {TestView} from "../views/testView.js";
import useModelProp from "../useModelProp.js";
import {Howl, Howler} from 'howler';
function Test(props) {
  const currentTask = useModelProp(userModel, "currentTask");
  const nextQuestion = useModelProp(userModel, "nextQuestion");
  const showRepeat = useModelProp(userModel, "showRepeat");
  const start = useModelProp(userModel, "start");
  return React.createElement(TestView, {
    nextQuestion: nextQuestion,
    showRepeat: showRepeat,
    start: start,
    onGreenS: () => userModel.setAnswer("greenSquare", userModel.currentTask),
    onRedS: () => userModel.setAnswer("redSquare", userModel.currentTask),
    onBlueS: () => userModel.setAnswer("blueSquare", userModel.currentTask),
    onYellowS: () => userModel.setAnswer("yellowSquare", userModel.currentTask),
    onPurpleS: () => userModel.setAnswer("purpleSquare", userModel.currentTask),
    onBlackS: () => userModel.setAnswer("blackSquare", userModel.currentTask),
    onWhiteS: () => userModel.setAnswer("whiteSquare", userModel.currentTask),
    onPinkS: () => userModel.setAnswer("pinkSquare", userModel.currentTask),
    
    onGreenC: () => userModel.setAnswer("greenCircle", userModel.currentTask),
    onRedC: () => userModel.setAnswer("redCircle", userModel.currentTask),
    onBlueC: () => userModel.setAnswer("blueCircle", userModel.currentTask),
    onYellowC: () => userModel.setAnswer("yellowCircle", userModel.currentTask),
    onPurpleC: () => userModel.setAnswer("purpleCircle", userModel.currentTask),
    onBlackC: () => userModel.setAnswer("blackCircle", userModel.currentTask),
    onWhiteC: () => userModel.setAnswer("whiteCircle", userModel.currentTask),
    onPinkC: () => userModel.setAnswer("pinkCircle", userModel.currentTask),
    onNext: () => {
      if (userModel.currentTask === userModel.instructions.length / 2 && userModel.secondTest === false) {
        props.history.push("/test/form");
      } else if (userModel.currentTask === userModel.instructions.length) {
        props.history.push("/test/form");
        userModel.uploadInfoFB();
      } else {
        userModel.playInstruction();
        userModel.nextQuestion = false
        userModel.showRepeat = true
        userModel.notifyObservers();
      }
    },
    onStart: () => {
      userModel.setGender();
    },
    onRepeat: () => {
      userModel.playInstructionRepeat();
      userModel.instructions[userModel.currentTask][0].repeatCounter += 1;
    }
  })
}

export default Test;